<template>
  <v-container fluid class="shift-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-shift`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Shift
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-items`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Items
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-schedule`"
          >
            <v-icon class="mr-3">mdi-calendar-clock</v-icon>
            Schedule
          </v-tab>    
          <v-tab
            class="mr-5"
            :href="`#tab-time`"
          >
            <v-icon class="mr-3">mdi-account-clock</v-icon>
            <span>Time</span>
            <span style="font-size: 10pt;"><sup>&nbsp;{{ (data_schedulestart) }}</sup></span>
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-view`"
          >
            <v-icon class="mr-3">mdi-calendar-search</v-icon>
            <span>View</span>
            <span style="font-size: 10pt;"><sup>&nbsp;{{ (data_schedulestart) }}</sup></span>
          </v-tab>          
          <v-tab-item
            :value="'tab-shift'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Shift</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeShift($event, 'shiftcode')"
                        v-bind:value="initvalue.shiftcode"
                        placeholder="Shift Code"
                        persistent-hint
                        single-line hint="Enter the shift code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeShift($event, 'shiftname')"
                        v-bind:value="initvalue.shiftname"
                        placeholder="Shift Name"
                        persistent-hint
                        single-line hint="Enter the shift name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=shifttype
                        :value="initvalue.shifttype"
                        outlined
                        dense
                        v-on:change="onChangeShift($event, 'shifttype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the shift type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeShift($event, 'shiftstatus')"
                          v-bind:label="initvalue.shiftstatus"
                          v-model="initvalue.shiftstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/shift/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editShiftRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Shift Items</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="success"
                          @click="isAddItem = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/shift/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="shiftrank"
                        :headers="header_item"
                        :items="shiftitems"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteItem" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_item.shifttype }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteItem = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteShiftItem(delete_item)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.employeeid="{ item }">
                          <p class="two-line" v-if="item.employeeid!=undefined"><b>{{ employees.length>0 && employees.find(i=>i._id == item.employeeid) ? employees.find(i=>i._id == item.employeeid)['employeename'] : ''  }}</b></p>
                          <p class="two-line" v-if="item.departmentid!=undefined">{{ departments.length>0 && departments.find(i=>i._id == item.departmentid) ? departments.find(i=>i._id == item.departmentid)['departmentname'] : ''  }}</p>
                        </template>
                        <template v-slot:item.weekday="{ item }">
                          <p class="two-line">{{ getWeekDay(item.weekday) }}</p>
                        </template>                   
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editShiftItemDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteShiftItemDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-schedule'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Shift Schedule</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="success"
                          @click="isAddSchedule = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/shift/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        item-key="_id"
                        sort-by="scheduledate"
                        show-select
                        single-select
                        :headers="header_schedule"
                        :items="shiftschedules"
                        v-model="data_selected"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteSchedule" width="500">
                            <v-card>
                              <v-card-title> Delete this Schedule? </v-card-title>
                              <v-card-text>
                                {{ delete_schedule.schedulename }} {{ delete_schedule.schedulemonth }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteSchedule = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteShiftSchedule(delete_schedule)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.scheduletype="{ item }">
                          {{ formatMonth(new Date(item.schedulestartdate)) }}
                        </template>
                        <template v-slot:item.schedulestartdate="{ item }">
                          {{ new Date(item.schedulestartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                        </template>
                        <template v-slot:item.scheduleenddate="{ item }">
                          {{ new Date(item.scheduleenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
                        </template>
                        <template v-slot:item.schedulestatus="{ item }">
                          <v-chip
                            v-if="item.schedulestatus!=undefined"
                            :color="getStatusColor(item.schedulestatus)"
                            small
                          >
                            {{ item.schedulestatus }}
                          </v-chip>
                        </template>           
                        <template v-slot:item.actions="{ item }">
                          <v-btn v-if="item.schedulestatus!='Active'" icon color="primary" @click="updateShiftScheduleConfirmDialog(item)">
                            <v-icon>mdi-text-box-edit</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="item.schedulestatus=='New'"
                            icon
                            color="primary"
                            @click="deleteShiftScheduleDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-time'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Shift Time</p>
                        
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          v-show="data_scheduleid!=null"
                          class="button-shadow mr-1"
                          color="success"
                          @click="isAddTime = true"
                        >
                          Add
                        </v-btn>
                        <v-btn color="success" class="button-shadow mr-1" @click="isFilterSchedule=true">
                          Filter
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-2"
                          color="primary"
                          to="/shift/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="scheduledate"
                        :headers="header_time"
                        :items="shifttimes"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTime" width="500">
                            <v-card>
                              <v-card-title> Delete this Time? </v-card-title>
                              <v-card-text>
                                {{ delete_time.employeename }} {{ delete_time.scheduletype }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTime = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteShiftTime(delete_time)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.scheduletype="{ item }">
                          <p class="two-line">{{ item.scheduletype  }}</p>
                          <p class="two-line">{{ item.schedulename || item.scheduledesc }}</p>                      
                        </template>
                        <template v-slot:item.scheduledate="{ item }">
                          <p class="two-line"><span style="font-size: 10pt; font-weight: 600;">{{ getWeekDay(item.weekday)  }}</span></p> 
                          <p class="two-line">{{ new Date(item.scheduledate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                        </template>              
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editShiftTimeDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteShiftTimeDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-view'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col class="pl-5 pr-5" cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Team On-Leave</p>
                      </v-col>
                    </v-row>
                    <v-row class="mb-4" no-gutters>
                      <v-col class="pl-1 pr-1" v-for="(item, index) in Object.keys( getScheduleTeamLeave() ) " :key="index" cols="12" md="2" sm="12">
                        <v-row class="mb-4" no-gutters>
                          <v-col cols="12" md="12">
                            <table style="width: 100%;">
                              <tr>
                                <td style=" padding-left: 5px;">
                                  <div style="align-content: center; height: 100%; font-size: 11pt; font-weight: 700; color: #111;">{{ formatShortDate(item).toUpperCase() }}</div>
                                </td>
                                <td style="text-align: right; padding-right: 20px;">
                                  <div style="align-content: center; height: 100%; font-size: 10pt; font-weight: 400; color: #222;">{{ formatShortDay(item) }}</div>
                                </td>
                              </tr>
                            </table>
                            <v-divider style="padding-bottom: 5px;"></v-divider>
                          </v-col>
                          <v-col v-for="(trans, index) in getScheduleTeamLeave()[item]" :key="index" class="ma-0 pr-2" cols="12" md="12">
                            <v-chip
                              v-if="trans!=null"
                              medium
                              class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                              :color="scheduleColor[trans.scheduletype]"
                            >
                              <v-icon :color="scheduleIconColor[trans.scheduletype]" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon[trans.scheduletype]}` }}</v-icon>
                              <div v-if="['Annual Leave', 'Sick Leave', 'Other Leave'].indexOf(trans.scheduletype)!=-1"><span style="font-size: 9pt; font-weight: 600;">{{  `${trans.employeename}`  }}</span>&nbsp;<span style="font-size: 8pt;">{{  `(${getCode(trans.scheduletype)}${trans.scheduledesc!=null && trans.scheduledesc!='' ? '-' + trans.scheduledesc : ''})`  }}</span></div>
                              <div v-else><span style="font-size: 9pt; font-weight: 600;">{{ trans.employeename}}:&nbsp;</span><span style="font-size: 8pt;">{{`${trans.starttime}-${trans.endtime}` }}</span></div>                  
                            </v-chip>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Team Shift</p>
                      </v-col>
                    </v-row>
                    <v-row class="mb-4" v-for="(item) in getMonthRange()" :key="item.toString()" no-gutters>
                      <v-col class="ma-0" cols="12" md="12">
                        <table style="width: 100%;">
                          <tr>
                            <td style=" padding-left: 5px;">
                              <div style="align-content: center; height: 100%; font-size: 11pt; font-weight: 700; color: #111;">{{ formatShortDate(item).toUpperCase() }}</div>
                            </td>
                            <td style="text-align: right; padding-right: 20px;">
                              <div style="align-content: center; height: 100%; font-size: 10pt; font-weight: 400; color: #222;">{{ formatDay(item) }}</div>
                            </td>
                          </tr>
                        </table>
                        <v-divider style="padding-bottom: 5px;"></v-divider>
                      </v-col>
                      <v-col v-for="(trans, index) in getScheduleHoliday(item)" :key="index" class="ma-0 pr-2" cols="12" md="12">
                        <v-chip
                          v-if="trans!=null"
                          medium
                          class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                          :color="scheduleColor[trans.scheduletype]"
                        >
                          <v-icon :color="scheduleIconColor[trans.scheduletype]" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon[trans.scheduletype]}` }}</v-icon>
                          <span style="font-size: 9pt; font-weight: 600;">{{ `${trans.scheduletype}`}}</span>&nbsp;<span style="font-size: 9pt;"> {{ `(${trans.scheduledesc})` }}</span>
                        </v-chip>
                      </v-col>
                      <v-col v-for="(trans, index) in getScheduleTeam(item)" :key="index" class="ma-0 pr-2" cols="12" md="2">
                        <v-chip
                          v-if="trans!=null"
                          medium
                          class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                          :color="scheduleColor[trans.scheduletype]"
                        >
                          <v-icon :color="scheduleIconColor[trans.scheduletype]" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon[trans.scheduletype]}` }}</v-icon>
                          <div v-if="['Annual Leave', 'Sick Leave', 'Other Leave'].indexOf(trans.scheduletype)!=-1"><span style="font-size: 9pt; font-weight: 600;">{{  `${trans.employeename}`  }}</span>&nbsp;<span style="font-size: 8pt;">{{  `(${getCode(trans.scheduletype)}${trans.scheduledesc!=null && trans.scheduledesc!='' ? '-' + trans.scheduledesc : ''})`  }}</span></div>
                          <div v-else><span style="font-size: 9pt; font-weight: 600;">{{ trans.employeename}}:&nbsp;</span><span style="font-size: 8pt;">{{`${trans.starttime}-${trans.endtime}` }}</span></div>                  
                        </v-chip>
                      </v-col>

                      <v-col v-if="getScheduleTeam(item).length==0 && getScheduleHoliday(item).length==0" class="ma-0 pa-0" cols="12" md="12">
                        <v-chip
                          medium
                          class="greyBold--text d-block mt-1 mb-1 font-weight-regular"
                          :color="scheduleColor['No Work Shift']"
                        >
                          <v-icon color="f8f8f8" left size="18" class="ml-0 mr-2">{{ `${scheduleIcon['No Work Shift']}` }}</v-icon>
                          No Work Shift
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_item.shiftrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="departments.map(x => {
                    return {text: x.departmentname, value: x._id};
                  })"
                  v-model="add_item.departmentid"
                  v-bind:error="errorindex == 3"
                  placeholder="Department"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="employees.filter(i=>i.departmentid==add_item.departmentid && (i.employeestatus=='Active' || i.employeestatus=='Contract')).map(x => {
                    return {text: x.employeename, value: x._id};
                  })"
                  v-model="add_item.employeeid"
                  v-bind:error="errorindex == 3"
                  placeholder="Employee"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="shift_type"
                  v-model="add_item.shifttype"
                  v-bind:error="errorindex == 1"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="days_of_week"
                  v-model="add_item.weekday"
                  v-bind:error="errorindex == 1"
                  placeholder="Day of Week"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  class="mb-4"
                  :items="start_time"
                  v-model="add_item.starttime"
                  v-bind:error="errorindex == 1"
                  placeholder="Start Time"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  class="mb-4"
                  :items="end_time"
                  v-model="add_item.endtime"
                  v-bind:error="errorindex == 1"
                  placeholder="End Time"
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddItem=false; add_item={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addShiftItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddSchedule"
      persistent
      width="500px"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Schedule</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="add_schedule.schedulestartdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="add_schedule.schedulestartdate"
                        v-on:change="onChangeStartDate($event)"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="add_schedule.schedulestartdate"
                        v-bind:error="errorindex == 2"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the start date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="add_schedule.schedulestartdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="onChangeStartDate(add_schedule.schedulestartdate); $refs.menu_startdate.save(add_schedule.schedulestartdate);"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    readonly
                    v-model="add_schedule.scheduleenddate"
                    label="End Date"
                    v-bind:value="add_schedule.scheduleenddate"
                    persistent-hint
                    single-line hint="Please choose the end date">
                  </v-text-field>
                </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddSchedule=false; add_schedule={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addShiftScheduleRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddTime"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Time</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_time.schedulerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="departments.map(x => {
                    return {text: x.departmentname, value: x._id};
                  })"
                  v-model="add_time.departmentid"
                  v-bind:error="errorindex == 3"
                  placeholder="Department"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="employees.filter(i=>i.departmentid==add_time.departmentid && (i.employeestatus=='Active' || i.employeestatus=='Contract')).map(x => {
                    return {text: x.employeename, value: x._id};
                  })"
                  v-model="add_time.employeeid"
                  v-bind:error="errorindex == 3"
                  placeholder="Employee"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="schedule_type"
                  v-model="add_time.scheduletype"
                  v-bind:error="errorindex == 1"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                  <v-menu
                    ref="menu_scheduledate"
                    v-model="menu_scheduledate"
                    :close-on-content-click="false"
                    :return-value.sync="add_time.scheduledate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="add_time.scheduledate"
                        v-on:change="onChangeStartDate($event)"
                        label="Schedule Date"
                        v-bind="attrs"
                        v-bind:value="add_time.scheduledate"
                        v-bind:error="errorindex == 2"
                        v-on="on"
                        single-line hint="Please choose the schedule date">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="add_time.scheduledate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_scheduledate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="onChangeStartDate(add_time.scheduledate); $refs.menu_scheduledate.save(add_time.scheduledate);"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              <v-col cols="12" md="2">
                <v-select
                  class="mb-4"
                  :items="start_time"
                  v-model="add_time.starttime"
                  v-bind:error="errorindex == 1"
                  placeholder="Start Time"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  class="mb-4"
                  :items="end_time"
                  v-model="add_time.endtime"
                  v-bind:error="errorindex == 1"
                  placeholder="End Time"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="add_time.scheduledesc"
                  class="mb-4"
                  placeholder="Description"
                  single-line
                  hint="Description"
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddTime=false; add_time={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addShiftTimeRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeItem($event, 'shiftrank')"
                  :value="edit_item.shiftrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="departments.map(x => {
                    return {text: x.departmentname, value: x._id};
                  })"
                  v-on:change="onChangeItem($event, 'departmentid')"
                  v-model="edit_item.departmentid"
                  :value="edit_item.departmentid"
                  placeholder="Department"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="employees.filter(i=>i.departmentid==edit_item.departmentid && (i.employeestatus=='Active' || i.employeestatus=='Contract')).map(x => {
                    return {text: x.employeename, value: x._id};
                  })"
                  v-on:change="onChangeItem($event, 'employeeid')"
                  :value="edit_item.employeeid"
                  placeholder="Employee"
                  dense
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="shift_type"
                  v-on:change="onChangeItem($event, 'shifttype')"
                  :value="edit_item.shifttype"
                  v-bind:error="errorindex == 1"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="days_of_week"
                  v-on:change="onChangeItem($event, 'weekday')"
                  :value="edit_item.weekday"
                  v-bind:error="errorindex == 1"
                  placeholder="Day of Week"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  class="mb-4"
                  :items="start_time"
                  v-on:change="onChangeItem($event, 'starttime')"
                  :value="edit_item.starttime"
                  v-bind:error="errorindex == 1"
                  placeholder="Start Time"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  class="mb-4"
                  :items="end_time"
                  v-on:change="onChangeItem($event, 'endtime')"
                  :value="edit_item.endtime"
                  v-bind:error="errorindex == 1"
                  placeholder="End Time"
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditItem=false; edit_item={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editShiftItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditTime"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Time</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeTime($event, 'schedulerank')"
                  :value="edit_time.schedulerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  readonly
                  class="mb-4"
                  :items="departments.map(x => {
                    return {text: x.departmentname, value: x._id};
                  })"
                  v-on:change="onChangeTime($event, 'departmentid')"
                  v-model="edit_time.departmentid"
                  :value="edit_time.departmentid"
                  placeholder="Department"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                readonly
                  class="mb-4"
                  :items="employees.filter(i=>i.departmentid==edit_time.departmentid && (i.employeestatus=='Active' || i.employeestatus=='Contract')).map(x => {
                    return {text: x.employeename, value: x._id};
                  })"
                  v-on:change="onChangeTime($event, 'employeeid')"
                  :value="edit_time.employeeid"
                  placeholder="Employee"
                  dense
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  class="mb-4"
                  :items="schedule_type"
                  v-on:change="onChangeTime($event, 'scheduletype')"
                  :value="edit_time.scheduletype"
                  v-bind:error="errorindex == 1"
                  placeholder="Type"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  readonly
                  :value="formatStdDate(edit_time.scheduledate)"
                  class="mb-4"
                  placeholder="Date"
                  single-line
                  hint="Date"
                  dense
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-select
                  class="mb-4"
                  :items="start_time"
                  v-on:change="onChangeTime($event, 'starttime')"
                  :value="edit_time.starttime"
                  v-bind:error="errorindex == 1"
                  placeholder="Start Time"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  class="mb-4"
                  :items="end_time"
                  v-on:change="onChangeTime($event, 'endtime')"
                  :value="edit_time.endtime"
                  v-bind:error="errorindex == 1"
                  placeholder="End Time"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  :value="edit_time.scheduledesc"
                  v-on:change="onChangeTime($event, 'scheduledesc')"
                  class="mb-4"
                  placeholder="Description"
                  single-line
                  hint="Description"
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditTime=false; edit_time={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editShiftTimeRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="isConfirmSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Confirm Schedule</span>
            </v-card-title>
            <v-card-text>
              {{ confirm_send.schedulename }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="confirm_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Confirm'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isConfirmSend=false; confirm_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="confirm_send.confirm!=='Confirm'"
                @click="updateShiftScheduleConfirm"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog
        v-model="isFilterSchedule"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Filter Schedule</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    :items="employees.filter(x=>x.employeestatus=='Active').map(x => {
                              return {text: x.employeename, value: x._id};
                            })"
                    v-model="filter_query.employeeid"
                    label="Employee"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                          <v-menu
                            ref="filter_scheduledate"
                            v-model="filter_scheduledate"
                            :close-on-content-click="false"
                            :return-value.sync="filter_query.scheduledate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="filter_query.scheduledate"
                                label="Schedule Date"
                                v-bind="attrs"
                                v-bind:value="filter_query.scheduledate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter schedule date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="filter_query.scheduledate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="filter_scheduledate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.filter_scheduledate.save(filter_query.scheduledate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFilterSchedule = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetSchedule"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="filterSchedule"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { getStatusColor, getFirstDay, getLastDay, formatMonth, formatStdDate, formatShortDate, formatDay, formatShortDay } from "../../../util/tools";
import router from '@/Routes';

export default {
  data () {
    return {
      header_item: [
        { text: "#", value: "shiftrank", width: "10px" },
        { text: "Employee|Department", value: "employeeid" },
        { text: "Shift Type", value: "shifttype", width: "15%" },
        { text: "Day of Week", value: "weekday", width: "12%" },
        { text: "Start", value: "starttime", width: "10%" },
        { text: "End", value: "endtime", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_schedule: [
        { text: "Schedule", value: "schedulename" },
        { text: "Month", value: "scheduletype", width: "15%" },
        { text: "Start", value: "schedulestartdate", width: "15%" },
        { text: "End", value: "scheduleenddate", width: "15%" },
        { text: 'Status', value: 'schedulestatus', width: "10%"},
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_time: [
        { text: "Date", value: "scheduledate", width: "12%" },
        { text: "Employee", value: "employeename" },
        { text: "Shift", value: "scheduletype", width: "20%" },
        { text: "Start", value: "starttime", width: "10%" },
        { text: "End", value: "endtime", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      shift: {},
      shiftitems: [],
      shiftschedules: [],
      shifttimes: [],
      data_selected: [],
      data_schedule: null,
      shifttype: ['Shift', 'Special Shift'],
      filter_scheduledate: null,
      menu_scheduledate: null,
      menu_startdate: null,
      menu_enddate: null,
      error: undefined,
      haserror: false,
      errorindex: undefined,
      add_item: {},
      add_schedule: {},
      add_time: {},
      edit_item: {},
      edit_schedule: {},
      edit_time: {},
      change_shift: {},
      change_item: {},
      change_schedule: {},
      change_time: {},
      delete_item: {},
      delete_schedule: {},
      delete_time: {},
      confirm_send: {},
      filter_query: {},
      isDeleteItem: false,
      isDeleteSchedule: false,
      isDeleteTime: false,
      isAddItem: false,
      isAddSchedule: false,
      isAddTime: false,
      isEditItem: false,
      isEditSchedule: false,
      isEditTime: false,
      isConfirmSend: false,
      isFilterSchedule: false,
      shift_type:['Work from Office', 'Work from Home', 'Work from Other', 'Contract Work'],
      schedule_type:['Work from Office', 'Work from Home', 'Work from Other', 'Contract Work', 'Business Travel', 'Annual Leave', 'Sick Leave', 'Other Leave', 'Holiday'],
      days_of_week: [
        {text: 'Sunday', value: 0},
        {text: 'Monday', value: 1},{text: 'Tuesday', value: 2},{text: 'Wednesday', value: 3},
        {text: 'Thursday', value: 4},{text: 'Friday', value: 5},{text: 'Saturday', value: 6}, 
      ],
      start_time: [
        '00:00',
        '07:00','07:15','07:30','07:45',
        '08:00','08:15','08:30','08:45',
        '09:00','09:15','09:30','09:45',
        '10:00','10:15','10:30','10:45',
        '11:00','11:15','11:30','11:45',
        '12:00','12:15','12:30','12:45',
        '13:00','13:15','13:30','13:45',
        '14:00','14:15','14:30','14:45',
        '15:00','15:15','15:30','15:45',
        '16:00','16:15','16:30','16:45',
        '17:00','17:15','17:30','17:45',
        '18:00','18:15','18:30','18:45',
        '19:00','19:15','19:30','19:45',
        '20:00','20:15','20:30','20:45',
        '21:00','21:15','21:30','21:45',
      ],
      end_time: [
        '08:00','08:15','08:30','08:45',
        '09:00','09:15','09:30','09:45',
        '10:00','10:15','10:30','10:45',
        '11:00','11:15','11:30','11:45',
        '12:00','12:15','12:30','12:45',
        '13:00','13:15','13:30','13:45',
        '13:00','13:15','13:30','13:45',
        '14:00','14:15','14:30','14:45',
        '15:00','15:15','15:30','15:45',
        '16:00','16:15','16:30','16:45',
        '17:00','17:15','17:30','17:45',
        '18:00','18:15','18:30','18:45',
        '19:00','19:15','19:30','19:45',
        '20:00','20:15','20:30','20:45',
        '21:00','21:15','21:30','21:45',
        '22:00','22:15','22:30','22:45',
        '23:00','23:15','23:30','23:45',
        '24:00',
      ],
      scheduleColor: {
          'No Work Shift': '#fafafa',
          'Work from Office': '#536dfe26',
          'Work from Home': '#dbf3fa',
          'Work from Other': '#dbf3fa',
          'Business Travel': '#dbf3fa',
          'Contract Work': '#9013fe26',
          'Annual Leave': '#ffc26026',
          'Other Leave': '#ffc26026',
          'Sick Leave': '#ffc26026',
          'Holiday': '#3cd4a026',
        },
        scheduleIconColor: {
          'No Work Shift': '#f8f8f8',
          'Work from Office': '#536dfe',
          'Work from Home': '#50b8e7',
          'Work from Other': '#50b8e7',
          'Business Travel': '#50b8e7',
          'Contract Work': '#663399',
          'Annual Leave': '#FFA62B',
          'Other Leave': '#FFA62B',
          'Sick Leave': '#FFA62B',
          'Holiday': '#3CB043',
        },
        scheduleIcon: {
          'No Work Shift': 'mdi-circle-outline',
          'Work from Office': 'mdi-office-building',
          'Work from Home': 'mdi-home',
          'Work from Other': 'mdi-store',
          'Business Travel': 'mdi-airplane',
          'Contract Work': 'mdi-briefcase-variant',
          'Annual Leave': 'mdi-calendar-heart',
          'Other Leave': 'mdi-calendar-multiselect',
          'Sick Leave': 'mdi-emoticon-sick-outline',
          'Holiday': 'mdi-island',
        },
      formatMonth: formatMonth,
      getStatusColor: getStatusColor,
      formatStdDate: formatStdDate,
      formatShortDate: formatShortDate,
      formatDay: formatDay,
      formatShortDay: formatShortDay,
    }
  },
  computed: {
    ...mapState('Department', ['departments']),
    ...mapState('Employee', ['employees']),
    ...mapState('Shift', ['isReceiving']),
    data_scheduleid(){
      if(this.data_selected==null || this.data_selected.length==0) return null;
      return this.data_selected[0]['_id'];
    },
    data_schedulestart(){
      if(this.data_selected==null || this.data_selected.length==0) return '';
      return this.formatMonth(new Date(this.data_selected[0]['schedulestartdate']));
    },
  },
  watch: {
    data_selected(){
      if(this.data_selected==null || this.data_selected.length==0) {
        this.data_schedule = null;
        this.shifttimes = [];
      }
      else {
        this.shifttimes = this.data_selected[0]['transactions'];
        this.data_schedule = Object.assign(this.data_selected[0]);
      }
      
    }
    
  },
  methods: {
    ...mapActions('Department', [ 'getDepartmentsRequest' ]),
    ...mapActions('Employee', [ 'getEmployeesRequest' ]),
    ...mapActions('Shift', [  'getShiftsRequest', 'deleteShiftItemRequest', 'deleteShiftScheduleRequest', 'deleteShiftTimeRequest', 
                              'insertShiftItemRequest', 'insertShiftScheduleRequest','insertShiftTimeRequest', 
                              'updateShiftRequest','updateShiftItemRequest', 'updateShiftTimeRequest', 'updateShiftScheduleConfirmRequest' ]),
    getWeekDay(daynum){
      if(daynum==0) return 'Sunday';
      if(daynum==1) return 'Monday';
      if(daynum==2) return 'Tuesday';
      if(daynum==3) return 'Wednesday';
      if(daynum==4) return 'Thursday';
      if(daynum==5) return 'Friday';
      if(daynum==6) return 'Saturday';
    },
    async addShiftItemRequest() {
      this.isAddItem = false;
      this.add_item.shiftid = this.initvalue._id;
      let result = await this.insertShiftItemRequest(this.add_item);
      this.shiftitems.push(result);
      this.add_item = {};
    },
    async addShiftScheduleRequest() {
      this.isAddSchedule = false;
      this.add_schedule.shiftid = this.initvalue._id;
      let result = await this.insertShiftScheduleRequest(this.add_schedule);
      this.shiftschedules.push(result);
      this.add_schedule = {};
    },
    async addShiftTimeRequest() {
      this.isAddTime = false;
      this.add_time.scheduleid = this.data_scheduleid;
      let result = await this.insertShiftTimeRequest(this.add_time);
      this.shifttimes.push(result);
      this.add_time = {};
    },
    deleteShiftItemDialog(item) {
      this.isDeleteItem = true;
      this.delete_item = { _id: item._id, shifttype: item.shifttype };
    },
    deleteShiftScheduleDialog(item) {
      console.log(item)
      this.isDeleteSchedule = true;
      this.delete_schedule = { _id: item._id, schedulename: item.schedulename, schedulemonth: this.formatMonth(new Date(item.schedulestartdate))};
    },
    deleteShiftTimeDialog(item) {
      this.isDeleteTime = true;
      this.delete_time = { _id: item._id, scheduletype: item.scheduletype, employeename: item.employeename };
    },
    async deleteShiftItem(payload) {
      this.isDeleteItem = false;
      let response = await this.deleteShiftItemRequest(payload);
      let index = this.shiftitems.findIndex((trans) => trans._id == response._id);
      this.shiftitems.splice(index, 1);
    },
    async deleteShiftSchedule(payload) {
      this.isDeleteSchedule = false;
      let response = await this.deleteShiftScheduleRequest(payload);
      let index = this.shiftschedules.findIndex((trans) => trans._id == response._id);
      this.shiftschedules.splice(index, 1);
    },
    async deleteShiftTime(payload) {
      this.isDeleteTime = false;
      let response = await this.deleteShiftTimeRequest(payload);
      let index = this.shifttimes.findIndex((trans) => trans._id == response._id);
      this.shifttimes.splice(index, 1);
    },
    editShiftItemDialog(item) {
      this.edit_item = Object.assign({}, item);
      this.change_item = {};
      this.isEditItem = true;
    },
    editShiftTimeDialog(item) {
      this.edit_time = Object.assign({}, item);
      this.change_time = {};
      this.isEditTime = true;
    },
    async editShiftRequest() {
      this.change_shift._id = this.initvalue._id;
      await this.updateShiftRequest(this.change_shift);
      router.push('/shift/list');
    },
    async editShiftItemRequest() {
      this.isEditItem = false;
      this.change_item.shiftitemid = this.edit_item._id;
      let response = await this.updateShiftItemRequest(this.change_item);
      let index = this.shiftitems.findIndex((x) => x._id == response._id);
      this.shiftitems.splice(index, 1, response);
      this.edit_item = {};
    }, 
    async editShiftTimeRequest() {
      this.isEditTime = false;
      this.change_time.shifttimeid = this.edit_time._id;
      let response = await this.updateShiftTimeRequest(this.change_time);
      let index = this.shifttimes.findIndex((x) => x._id == response._id);
      this.shifttimes.splice(index, 1, response);
      this.edit_time = {};
    }, 
    resetSchedule(){
      this.filter_query = {};
      let results = Object.assign([],this.data_selected[0]['transactions']);
      this.shifttimes = Object.assign([], results);
      this.isFilterSchedule = false;
    },
    filterSchedule(){
      let results = Object.assign([],this.data_selected[0]['transactions']);
      if(this.filter_query.employeeid && this.filter_query.scheduledate) {
        results = results.filter(i=>i.employeeid==this.filter_query.employeeid && (new Date(i.scheduledate).getTime()==new Date(this.filter_query.scheduledate).getTime()));
      }
      else{
        if(this.filter_query.employeeid) results = results.filter(i=>i.employeeid==this.filter_query.employeeid);
        else if(this.filter_query.scheduledate) results = results.filter(i=>(new Date(i.scheduledate).getTime()==new Date(this.filter_query.scheduledate).getTime()));
        else results = [];
      }
      console.log(results, this.filter_query)
      this.shifttimes = Object.assign([], results);
      this.isFilterSchedule = false;
    },
    onChangeShift(value, field){
      this.change_shift[field] = value;
    },
    onChangeItem(value, field){
      this.change_item[field] = value;
    },  
    onChangeTime(value, field){
      this.change_time[field] = value;
    },
    onChangeStartDate(value) {
      let date = new Date(value);
      let start_date = getFirstDay(date);
      let end_date = getLastDay(date);
      this.add_schedule = Object.assign({}, this.add_schedule, {schedulestartdate: start_date, scheduleenddate: end_date});
    },
    updateShiftScheduleConfirmDialog(item) {
      this.isConfirmSend = true;
      this.confirm_send = {
        _id: item._id,
        schedulename: item.schedulename,
      };
    },
    async updateShiftScheduleConfirm() {
      this.isConfirmSend = false;
      let result = await this.updateShiftScheduleConfirmRequest(this.confirm_send);
      let index = this.shiftschedules.findIndex((x) => x._id == result._id);
      this.shiftschedules.splice(index, 1, result);
      this.confirm_send = {};
    },


    getCode(type){
        let words = type.split(" ");
        let text = words[0][0].toUpperCase() + words[1][0].toUpperCase();
        return text;
      },
      getMonthRange(){
            let range = [];
            if(this.data_schedule==null) return range;
            let startdate = this.data_schedule.schedulestartdate;
            let enddate = this.data_schedule.scheduleenddate;
            let date = new Date(startdate);
            let edate = new Date(enddate);
            let i = 0;
            while (date <= edate) {
                range.push(date);
                date = new Date(new Date(date).getTime()+(1*24*60*60*1000));
                i = i+1;
            }
            return range;
          },
          getSchedule(date){
            if(this.data_schedule==null) return [];
            let results = this.data_schedule.transactions.filter(i=> new Date(i.scheduledate).getTime() == new Date(date).getTime());
            results.sort((a,b) =>{
                if (b.starttime > a.starttime) return -1;
                if (a.starttime < b.starttime) return 1;
                return 0;
            });
            return results;
          },
          getScheduleTeam(date){
            if(this.data_schedule==null) return [];
            let results = this.data_schedule.transactions.filter(i=> new Date(i.scheduledate).getTime() == new Date(date).getTime() && i.scheduletype!='Holiday');
            results.sort((a,b) =>{
                if (b.starttime > a.starttime) return -1;
                if (a.starttime < b.starttime) return 1;
                return 0;
            });
            return results;
          },
          getScheduleTeamLeave(){
            if(this.data_schedule==null || this.data_schedule.transactions==null) return [];
            let results = [...this.data_schedule.transactions.filter(i=>i.scheduletype.includes('Leave'))]
            results.sort((a,b) =>{
                if (b.scheduledate > a.scheduledate) return -1;
                if (a.scheduledate < b.scheduledate) return 1;
                return 0;
            });
            let object = Object.groupBy(results, item => {
              return item.scheduledate;
            });
            return object;
          },
          getScheduleHoliday(date){
          if(this.data_schedule==null) return [];
            let holidays = this.data_schedule.transactions.filter(i=> new Date(i.scheduledate).getTime() == new Date(date).getTime() && i.scheduletype=='Holiday');
            let results = this.data_schedule.transactions.filter(i=> new Date(i.scheduledate).getTime() == new Date(date).getTime() && i.scheduletype!='Holiday');
            results.sort((a,b) =>{
                if (b.starttime > a.starttime) return -1;
                if (a.starttime < b.starttime) return 1;
                return 0;
            });
            if(holidays.length==0) return [];
            return [holidays[0]];
          },


  },
  async created () {
    this.initvalue = this.$route.params;
    this.shiftitems = this.initvalue.items;
    this.shiftschedules = this.initvalue.schedules;
    if(this.shiftschedules!=null && this.shiftschedules.length!=0) {
      this.data_selected = Object.assign([this.shiftschedules[0]]);
      this.data_schedule = Object.assign(this.shiftschedules[0]);
    }
    
    if(!this.initvalue._id) this.$router.push({ name: 'ShiftList' });
    if(this.departments.length==0) await this.getDepartmentsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
